import React from "react";

const CriticalityScore = ({ value = 0 }) => {
  const segments = [
    { color: "#F6E39B" },
    { color: "#FACC15" },
    { color: "#FB923C" },
    { color: "#F43F5E" },
    { color: "#BE123C" }
  ];

  const score = parseFloat(value) || 0;

  const snapped =
    Math.abs(score - Math.round(score)) <= 0.05 ? Math.round(score) : score;

  const pct = (snapped / 5) * 100;

  const colorIndex = Number.isInteger(snapped)
    ? Math.min(4, Math.max(0, snapped - 1))
    : Math.min(4, Math.max(0, Math.ceil(snapped) - 1));

  const thumbColor = snapped > 0 ? segments[colorIndex].color : "#555";

  return (
    <div style={{ marginBottom: 10, width: 150 }}>
      <div style={{ position: "relative", height: 10, borderRadius: 6 }}>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            borderRadius: 6,
            overflow: "hidden"
          }}
        >
          {segments.map((seg, i) => {
            const segStart = i;
            const segEnd = i + 1;

            let fillPct = 0;
            if (score >= segEnd) {
              fillPct = 100;
            } else if (score > segStart) {
              fillPct = (score - segStart) * 100;
            }

            return (
              <React.Fragment key={i}>
                {i !== 0 && (
                  <div style={{ background: "#fff", flexShrink: 0 }} />
                )}
                <div
                  style={{
                    flex: 1,
                    position: "relative",
                    background: "#E5E7EB"
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      height: "100%",
                      width: `${fillPct}%`,
                      background: seg.color
                    }}
                  />
                </div>
              </React.Fragment>
            );
          })}
        </div>

        <div
          style={{
            position: "absolute",
            left: `${pct}%`,
            top: "50%",
            width: 14,
            height: 14,
            borderRadius: "50%",
            background: "#fff",
            border: `3px solid ${thumbColor}`,
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            zIndex: 2
          }}
        />
      </div>
    </div>
  );
};

export default CriticalityScore;
